@if (toolchain(); as toolchain) {
  <div class="toolchain-layout">
    <div class="timeline">
      @for (item of timelineSteps(); track item.step.stepNo) {
        @let step = item.step;
        @if (!$first) {
          <div
            class="job-stage-transition"
            [class.is-upcoming]="!isInitialLoading() && item.future"
            aria-hidden="true">
            <div class="job-stage-divider"></div>
            <div class="job-connector"></div>
          </div>
        }
        <app-job-timeline
          [attr.id]="'toolchain-step-' + step.stepNo"
          [class.is-upcoming]="!isInitialLoading() && item.future"
          [job]="item.job || undefined"
          [tool]="toolchain.tools[step.toolId]"
          [disabled]="!isInitialLoading() && item.future"
          [isInitialLoading]="isInitialLoading() || (item.active && populatedOutputs.isLoading())"
          [outputsToMap]="item.active ? activeInputMapping() || step.inputMapping : []"
          [rerunStep]="item.job ? item.rerun : undefined"
          [startJob]="startJobFor(item, $first)"
          (jobStarting)="jobStarting.emit($event)"></app-job-timeline>
      }
    </div>
    @if (!isInitialLoading()) {
      <app-toolchain-timeline-legend [steps]="timelineSteps()"></app-toolchain-timeline-legend>
    }
  </div>
}
